export const get_class_color = (bg_color, premium, bg=true) => (bg?"bg-":"")+(premium?(bg_color):"locked-grey")+(bg?"-bg":"");

